import React, {Component} from 'react';
import {IProps, IState} from "./types";
import {chatTyping} from "../../utils/api/subscribe";
import {sendMessage, sendTyping} from "../../utils/api/send";
import * as Scroll from 'react-scroll';
import * as Notifications from '../../components/Notification'
import MessageList from "../../components/MessageList";
import TypingPlaceholder from "../../components/TypingPlaceholder";
import InputBar from "../../components/InputBar"
import {connect} from "react-redux";
import {REDUCER_TYPE} from "../../modules/Reducer";
import {Dropdown, DropdownAction} from "../../components/Dropdown";
import globalChatIcon from "../../assets/img/global_chat.svg";
import chevronIcon from "../../assets/img/chevron.svg";
import {SetSelectedChat, UpdateUnreadPrivateChats, UpdateUnreadGroupChat} from "../../modules/Actions";
import { ChatThread } from "../../types";

class MessageContainer extends Component <IProps, IState> {
    protected messageList: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            sendingTyping: false,
            messages: this.props.messages,
            tabClass: props.tabClass,
            selectedChatId: this.props.state?.selectedChat || 'group',
        };

        this.catchMessageTyping();
    }

    componentDidMount(): void {
        setTimeout(() => {
            this.scrollListToBottom();
        }, 200)
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
        if (this.state.tabClass !== this.props.tabClass) {
            this.setState({tabClass: this.props.tabClass})
        }

        if (!prevProps.state.authUser && this.props.state.authUser) {
            Notifications.watch(this.props.state.authUser);
        }

        if (this.state.messages !== this.props.messages) {
            this.setState({
                messages: this.props.messages
            })
        }

        if (prevState.selectedChatId !== this.state.selectedChatId) {
            setTimeout(() => {
                this.scrollListToBottom();
            }, 0);
            this.props.dispatch?.(SetSelectedChat(this.state.selectedChatId || 'group'));
            this.clearUnreadForChat(this.state.selectedChatId || 'group');
        }

        if (this.props.state.isGrouped === 1) {
            const participants = (this.props.state.participants || []).filter((participant: any) =>
                this.getParticipantKey(participant) !== this.props.state.authUser?.uuid
            );
            const hasSelected = participants.some((participant: any) =>
                this.getParticipantKey(participant) === this.state.selectedChatId
            );
            if (this.state.selectedChatId && this.state.selectedChatId !== 'group' && !hasSelected) {
                this.setState({selectedChatId: 'group'});
            }
        }

        if (
            prevProps.state.selectedChat !== this.props.state.selectedChat
            && this.props.state.selectedChat
            && this.props.state.selectedChat !== this.state.selectedChatId
        ) {
            this.setState({selectedChatId: this.props.state.selectedChat});
        }
    }

    handleSubmit = (value: string) => {
        if (!value) return;
        if (this.state.selectedChatId && this.state.selectedChatId !== 'group') {
            sendMessage(value, this.state.selectedChatId);
            return;
        }
        sendMessage(value);
    };

    sendTyping = () => {
      if (this.state.sendingTyping) return false;

        const chatId = this.state.selectedChatId || 'group';

        console.log('???')
        this.setState({
            sendingTyping: true
        }, () => {
            sendTyping(chatId);
            setTimeout(() => {
                this.setState({
                    sendingTyping: false
                })
            }, 500)
        })
    }

    catchMessageTyping = () => {
        chatTyping((data: any) => {
            const incomingChatId = String(data?.chatId || 'group');
            const currentChatId = String(this.state.selectedChatId || 'group');

            console.log(incomingChatId, currentChatId)
            // pokazuj typing tylko dla aktualnie otwartego czatu
            if (incomingChatId !== currentChatId) {
                return false;
            }

            // opcjonalnie: nie pokazuj "pisze..." jeśli to ja
            if (data?.participant?.uuid && data.participant.uuid === this.props.state.authUser?.uuid) {
                return false;
            }

            if (this.state.isTyping) return true;

            this.setState({
                isTyping: true,
                whoTyping: data.participant,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isTyping: false,
                        whoTyping: undefined,
                    })
                }, 3000)
            })
        });
    };

    scrollListToBottom = () => {
        Scroll.animateScroll.scrollToBottom({
            containerId: "messagesList",
            duration: 200,
        })
    };

    clearUnreadForChat = (chatId: string) => {
        if (chatId === 'group') {
            if (this.props.state.unreadGroupChat) {
                this.props.dispatch?.(UpdateUnreadGroupChat(0));
            }
            return;
        }
        if (!chatId || chatId === 'group') {
            return;
        }
        const unreadPrivateChats = (this.props.state.unreadPrivateChats || {}) as Record<string, number>;
        if (!unreadPrivateChats[chatId]) {
            return;
        }
        const updatedUnread = {
            ...unreadPrivateChats,
            [chatId]: 0
        };
        this.props.dispatch?.(UpdateUnreadPrivateChats(updatedUnread));
    };

    getParticipantKey = (participant: any) => {
        return String(
            participant?.uuid
            || participant?.participant_uuid
            || participant?.participantUuid
            || participant?.id
            || ''
        );
    };

    renderGroupDropdown = () => {
        const isGrouped = this.props.state.isGrouped === 1;
        if (!isGrouped) {
            return null;
        }


        const threads = Array.isArray(this.props.state.chatThreads) ? this.props.state.chatThreads : [];
        const authUuid = String(this.props.state.authUser?.uuid || '');
        const privateChats = threads
            .map((t: any) => ({
                chatId: String(t?.participant?.uuid || ''),
                name: String(t?.participant?.name || 'Czat prywatny'),
            }))
            .filter((c: any) => !!c.chatId && c.chatId !== authUuid);

        const unreadPrivateChats = (this.props.state.unreadPrivateChats || {}) as Record<string, number>;
        const hasUnread = Object.values(unreadPrivateChats).some((value) => value > 0)
            || (this.props.state.unreadGroupChat || 0) > 0;
        const actions: DropdownAction[] = [
            {
                key: 'group',
                label: (
                    <div className="group-chat-option">
                        <span
                            className={`group-chat-option__dot ${(this.props.state.unreadGroupChat || 0) > 0 ? 'is-visible' : ''}`}
                            aria-hidden="true"
                        />
                        <span className="group-chat-option__label">Czat grupowy</span>
                    </div>
                ),
                active: this.state.selectedChatId === 'group',
                onClick: () => this.setState({selectedChatId: 'group'})
            },
            ...privateChats.map((chatThread: ChatThread) => {
                const participantKey = chatThread.chatId
                const unreadCount = participantKey
                    ? Object.entries(unreadPrivateChats).reduce((acc, [key, value]) => {
                        if (key === participantKey) {
                            return acc + Number(value || 0);
                        }
                        return acc;
                    }, 0)
                    : 0;

                return {
                key: participantKey,
                label: (
                    <div className="group-chat-option">
                        <span
                            className={`group-chat-option__dot ${unreadCount > 0 ? 'is-visible' : ''}`}
                            aria-hidden="true"
                        />
                        <span className="group-chat-option__label">{chatThread.name}</span>
                    </div>
                ),
                active: participantKey === this.state.selectedChatId,
                onClick: () => this.setState({selectedChatId: participantKey})
                };
            })
        ];


        console.log(actions)
        const selectedLabel = this.state.selectedChatId === 'group'
            ? 'Czat grupowy'
            : privateChats.find((thread: ChatThread) => thread.chatId === this.state.selectedChatId)?.name || 'Czat grupowy';

        return (
            <div className="messages-header__group-chat">
                <Dropdown
                    actions={actions}
                    buttonLabel={
                        <div className="group-chat-trigger">
                            <span className="group-chat-trigger__icon" aria-hidden="true">
                                <img src={globalChatIcon} alt="" />
                            </span>
                            <span className="group-chat-trigger__label">{selectedLabel}</span>
                            <span className="group-chat-trigger__chevron" aria-hidden="true">
                                <img src={chevronIcon} alt="" />
                            </span>
                            {hasUnread ? (
                                <span className="group-chat-trigger__dot" aria-hidden="true" />
                            ) : null}
                        </div>
                    }
                    menuPosition="down"
                    variant="chat"
                />
            </div>
        );
    }

    renderList = () => {
        const isGrouped = this.props.state.isGrouped === 1;
        const selectedChatId = this.state.selectedChatId || 'group';
        const chatMessages = this.props.chatMessages || this.props.state.chatMessages || {};
        const messages = isGrouped && selectedChatId !== 'group'
            ? (chatMessages?.[selectedChatId] || [])
            : this.state.messages;
        return <MessageList
            isTyping={this.state.isTyping}
            whoTyping={this.state.whoTyping}
            messages={messages}
        />
    }

    render() {
        const isGrouped = this.props.state.isGrouped === 1;
        const containerClassName = `${this.state.tabClass} ${isGrouped ? 'messages-has-group' : ''}`.trim();
        return (
            <div className={containerClassName}>
                {this.props.header && (
                    <div className="messages-header">
                        {this.props.header}
                    </div>
                )}
                <div className="messages" ref={list => {
                    this.messageList = list
                }}>
                    {this.renderGroupDropdown()}
                    {this.renderList()}
                    <div className="messages-bar-container">
                        <TypingPlaceholder
                            whoTyping={this.state.whoTyping}
                            isTyping={this.state.isTyping}
                        />
                        <InputBar
                          onSubmit={(value: string) => {
                            this.handleSubmit(value)
                          }}
                          sendTyping={this.sendTyping}
                          chatId={this.state.selectedChatId || 'group'}
                          isNodeDisconnected={this.props.state.isNodeDisconnected}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: REDUCER_TYPE) => {
    return {
        state: state
    }
}

// @ts-ignore
export default connect(mapStateToProps)(MessageContainer);
